import dialTone from "./video_dial_tone.mp3";
import receiverTone from "./video_reciever_tone.mp3";
import chatNoti from "./chatNoti.mp3"

export const AssetsAudio = {
  DialTone: dialTone,
  ReceiverTone: receiverTone,
  ChatNoti: chatNoti,
};
